var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-responsive" },
    [
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.anulado === "N",
                      expression: "anulado === 'N'"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: { disabled: _vm.disabled, type: "button" },
                  on: { click: _vm.agregarDetalle }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              )
            ]),
            _vm._v(" "),
            _c("th"),
            _vm._v(" "),
            _c("th", [_vm._v("Código")]),
            _vm._v(" "),
            _c("th", [_vm._v("Descripción")]),
            _vm._v(" "),
            _c("th", [_vm._v("Precio")]),
            _vm._v(" "),
            _c("th", [_vm._v("Cantidad")]),
            _vm._v(" "),
            _c("th", [_vm._v("Descuento")]),
            _vm._v(" "),
            _c("th", [_vm._v("Impuestos")]),
            _vm._v(" "),
            _c("th", [_vm._v("Total")]),
            _vm._v(" "),
            _c("th")
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.modelValue, function(row, index) {
              return _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.similiarToSearch(row.nombre_item) ||
                        _vm.similiarToSearch(row.id_item),
                      expression:
                        "similiarToSearch(row.nombre_item) || similiarToSearch(row.id_item)"
                    }
                  ],
                  key: _vm.moment(new Date()).format("YYYYMMDDHHmmss") + index
                },
                [
                  _c("th", { attrs: { scope: "row" } }, [
                    _vm._v("\n          " + _vm._s(index + 1) + "\n        ")
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-info btn--text",
                        attrs: { disabled: _vm.disabled, type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.editarDetalle(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-edit" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly: "",
                            id: "idItem" + index,
                            value: row.id_item,
                            placeholder: "Código"
                          }
                        },
                        [
                          _vm.erroresFormulario.hasOwnProperty(
                            "items." + index + ".id_item"
                          )
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.erroresFormulario[
                                          "items." + index + ".id_item"
                                        ][0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      attrs: {
                        tooltip:
                          row.nombre_item !== ""
                            ? row.nombre_item
                            : "Seleccione..."
                      }
                    },
                    [
                      _c("input-field", {
                        attrs: {
                          readonly: "",
                          id: "nombreItem" + index,
                          value: row.nombre_item,
                          placeholder: "Nombre"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.moneyPersonalizado,
                            readonly: "",
                            id: "precio" + index,
                            value: row.precio,
                            placeholder: "Precio"
                          }
                        },
                        [
                          _vm.erroresFormulario.hasOwnProperty(
                            "items." + index + ".precio"
                          )
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.erroresFormulario[
                                          "items." + index + ".precio"
                                        ][0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.decimalPersonalizado,
                            readonly: "",
                            id: "cantidad" + index,
                            value: row.cantidad,
                            placeholder: "Precio"
                          }
                        },
                        [
                          _vm.erroresFormulario.hasOwnProperty(
                            "items." + index + ".cantidad"
                          )
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.erroresFormulario[
                                          "items." + index + ".cantidad"
                                        ][0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.money,
                            readonly: "",
                            id: "totalDescuento" + index,
                            value: row.total_descuento,
                            placeholder: "Descuento"
                          }
                        },
                        [
                          _vm.erroresFormulario.hasOwnProperty(
                            "items." + index + ".total_descuento"
                          )
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.erroresFormulario[
                                          "items." + index + ".total_descuento"
                                        ][0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("input-field", {
                        attrs: {
                          vMoney: "",
                          format: _vm.money,
                          readonly: "",
                          id: "totalImpuestos" + index,
                          value: row.total_impuestos,
                          placeholder: "Impuestos"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.money,
                            readonly: "",
                            id: "total" + index,
                            value: row.total,
                            placeholder: "Total"
                          }
                        },
                        [
                          _vm.erroresFormulario.hasOwnProperty(
                            "items." + index + ".total"
                          )
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.erroresFormulario[
                                          "items." + index + ".total"
                                        ][0]
                                      )
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-danger btn--text",
                        attrs: { disabled: _vm.disabled, type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.eliminarDetalle(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-trash-o" })]
                    )
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.modelValue.length === 0,
                    expression: "modelValue.length === 0"
                  }
                ]
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { scope: "row", colspan: "5" } }, [
                _vm._v("Totales")
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.totalCantidades))]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("td", [
                _vm._v("$ " + _vm._s(_vm.totalItems.toLocaleString(_vm.locale)))
              ])
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            width: "70%",
            name: "itemComprobante",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("item-comprobante", {
            attrs: {
              grava_iva: _vm.grava_iva,
              decimales_compras: _vm.decimales_compras,
              moneyPersonalizado: _vm.moneyPersonalizado,
              decimalPersonalizado: _vm.decimalPersonalizado,
              precioEditable: _vm.precioEditable,
              tipo: _vm.tipo,
              tipoComprobante: _vm.tipoComprobante,
              valorIrbpnr: _vm.irbpnr
            },
            on: { cancelar: _vm.cancelarDetalle, input: _vm.aceptarDetalle },
            model: {
              value: _vm.selectedItem,
              callback: function($$v) {
                _vm.selectedItem = $$v
              },
              expression: "selectedItem"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "9" } }, [
      _c("strong", [_vm._v("No se ha agregado detalles en el comprobante.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Total de cantidades")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Total ($)")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2403cbee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2403cbee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/TablaDetalleComprobante.vue
// module id = 393
// module chunks = 0